import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { GET_CLINIC_LISTING_CONST } from "../../constants";
import { GET_FULLSTORY_FLAG } from "../../constants/fullstory/fullStoryConst";

const GET_FULLSTORY_FLAG_QUERY = gql`
query GetFullstoryFlag($type: String) {
    getFullstoryFlag(type: $type) {
      success
      message
      data {
        tracking_allowed
      }
    }
}`;

export const GetFullstoryFlag = () => {
  const dispatch = useDispatch();
  const [getFullstoryFlagData, fullstoryFlagData] = useLazyQuery(
    GET_FULLSTORY_FLAG_QUERY,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-and-network",
      onCompleted: ({ getFullstoryFlag: responseData }) => {
        dispatch({
          type: GET_FULLSTORY_FLAG,
          payload: responseData.data,
        });
        if (responseData.success) {
        } else {
        }
      },
    }
  );
  const fullstoryFlagQueryData = fullstoryFlagData;
  const initGetFullstoryFlag = (data, successCallback) => {
    getFullstoryFlagData({
      variables: data,
    }).then(({ data: { getFullstoryFlag: responseData } }) => {
      if (responseData.success) {
        if (successCallback)
          successCallback(responseData?.data);
      }
    });
  };
  return { initGetFullstoryFlag, fullstoryFlagQueryData };
};